<template>
  <div v-if="popups.length !== 0" class="popup-wrap">
    <div
      v-for="popup in popups"
      :key="popup.key"
      class="popup acard mt-2"
      :class="popup.type"
      :fading="popup.fading"
    >
      <div class="mr-3 ml-1 d-flex align-items-center">
        <div class="rounded-circle popup-circle d-flex align-items-center justify-content-center">
          <i class="fas" :class="typeIcon(popup.type)"></i>
        </div>
      </div>
      <div>
        <div class="text-capitalize message-header mb-1">{{popup.type}}</div>
        <div class="message-text">{{popup.message}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popups: []
    };
  },
  methods: {
    typeIcon: function(type) {
      if (type === "success") {
        return "fa-check";
      }

      if (type === "notification") {
        return "fa-bell";
      }

      if (type === "error") {
        return "fa-exclamation";
      }
    },
    removePopup: function(date) {
      setTimeout(() => {
        //Create fading timeout
        this.popups = this.popups.map(item => {
          if (item.date === date) {
            item.fading = true;
          }

          return item;
        });
      }, 5 * 1000);

      setTimeout(() => {
        //Create fading timeout
        this.popups = this.popups.filter(
          item => item.date !== date
        );
      }, 6 * 1000);
    },
    addPopup: function(data) {
      const processedData = {};
      if (typeof data === "string") {
        processedData.message = data;
        processedData.type = "success";
      } else {
        processedData.message = data.message;
        processedData.type = data.type;
      }

      processedData.date = new Date();
      processedData.key = processedData.date.toISOString();
      processedData.fading = false;

      this.popups.push(processedData);
      this.removePopup(processedData.date);
    }
  },
  created() {
    this.$root.$on("popup", this.addPopup);
  }
};
</script>

<style lang="scss" scoped>

@keyframes fadeinup {
  0% {
    opacity: 0;
    bottom: -0.9375rem;
  }
  100% {
    opacity: 1;
    bottom: 0;
  }
}

@keyframes fadeoutup {
  0% {
    opacity: 1;
    bottom: 0;
  }
  100% {
    opacity: 0;
    bottom: 0.9375rem;
  }
}
.popup-wrap {
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 10000;
}

.popup {
  animation: fadeinup 0.6s;
  position: relative;
  align-items: center;
  display: flex;
  background-color: white;
  border-radius: 0.25rem;
  box-shadow: 0 0 1.25rem 0 rgba(0, 0, 0, 0.15);

  &[fading] {
    animation: fadeoutup 0.6s;
    opacity: 0;
  }

  &.acard {
    padding: 1rem;
    width: 23rem;
    margin-top: 0.5rem;
  }

  .message-header {
    line-height: 1;
    font-size: 1rem;
    font-weight: 600;
  }

  .message-text {
    color: #555;
    font-size: 0.875rem;
    line-height: 1.2;
  }

  .popup-circle {
    width: 3.125rem;
    height: 3.125rem;
    font-size: 1.5rem;
  }

  &.success {
    color: rgb(63, 160, 0);

    .popup-circle {
      background-color: rgba(63, 160, 0, 0.44);
    }
  }

  &.notification {
    color: rgb(56, 106, 182);

    .popup-circle {
      background-color: rgba(56, 106, 182, 0.44);
    }
  }

  &.error {
    color: rgb(158, 8, 8);

    .popup-circle {
      background-color: rgba(158, 8, 8, 0.44);
    }
  }
}
</style>